module.exports = __webpack_public_path__ + "img/logo-interra-2.c6775a7f.svg";